export const blockIconsFileDownload = (
	<span className='material-symbols-outlined'>download</span>
);
